import { Col, Row, Tooltip } from 'react-bootstrap';
import GNESearch from 'components/shared/search/GNESearch';
import LinkButton from 'components/shared/button/LinkButton';
import { ReactSelect } from 'components/shared/dropdown/GNESingleSelect';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import { useState, useImperativeHandle, forwardRef } from 'react';
import './TabHeader.scss';
import { INSIGHT_TYPE, NUMBER_ZERO } from 'constants/constants';

const TabHeader = forwardRef(
  ({ page, filterViewOptions, handleSearch }, ref) => {
    const [searchedText, setSearchedText] = useState('');
    const [selectedDropdownValue, setSelectedDropdownValue] = useState(
      filterViewOptions[NUMBER_ZERO]
    );

    const tooltip = () => {
      return (
        <Tooltip className='gne-tooltip'>
          <span className='text text__x-small'>
            If you'd like to submit your insight board for availability to C360
            users, please submit a ticket by clicking the Help button at the top
            right and selecting "Raise Request". We will get in touch with you
            and assist in publishing it as a sample insight board.
          </span>
        </Tooltip>
      );
    };

    const handleClear = () => {
      setSearchedText('');
      setSelectedDropdownValue(filterViewOptions[NUMBER_ZERO]);
      handleSearch('', filterViewOptions[NUMBER_ZERO]?.value);
    };

    const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchedText(value);
    };

    const handleDropdownChange = (value) => {
      setSelectedDropdownValue(value);
      handleSearch(searchedText, value.value);
    };

    // Expose handleClear function to parent component
    useImperativeHandle(ref, () => ({
      clearSearch: handleClear,
    }));

    return (
      <Row className='align-items-center mt-4 d-flex justify-content-between'>
        <Col
          sm={4}
          className='ps-0'>
          <GNESearch
            type='text'
            value={searchedText}
            onSearch={(value) => handleSearch(value, selectedDropdownValue)}
            onChange={handleSearchChange}
            className='text text__small search-lg'
            placeholder={
              page === INSIGHT_TYPE.GENERAL
                ? 'Search by Name or Customer Type'
                : 'Search by Name, Publisher, or Customer Type'
            }
            onClear={handleClear}
          />
        </Col>
        <Col
          sm={page === INSIGHT_TYPE.GENERAL ? 2 : 4}
          className='pe-0'>
          {page === INSIGHT_TYPE.GENERAL ? (
            <div>
              <ReactSelect
                onChange={handleDropdownChange}
                value={selectedDropdownValue}
                options={filterViewOptions}
                placeholder={'All Insights Board'}
                className='single-select text text__small'
              />
            </div>
          ) : (
            <div className='text-end'>
              <OverlayTrigger
                overlay={tooltip()}
                placement='bottom'>
                <i className={`icon icon__info_icon-yellow`} />
              </OverlayTrigger>
              <span className='text text__bold text__small mb-4 '>
                Submit Your Insight Boards
              </span>
            </div>
          )}
        </Col>
      </Row>
    );
  }
);

export default TabHeader;
